import React, { useState } from 'react';
import { Col, Container, Row, FormCheck, Form, Dropdown } from 'react-bootstrap';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';
import '../../../styles/ProvisioningInfo.css';
import { HHIEButton } from '../../utility/HHIEButton';

export default function ModifyProvisioning({member,pass,setOverride }) {
    const [npiStat, setNpiStat] = useState(pass.npiPassStatus);
    const [npiNoCheck, setNpiNoCheck] = useState(pass.npiNoCheck);
    const [dccaStat, setDccaStat] = useState(pass.dccaPassStatus);
    const [dccaNoCheck, setDccaNoCheck] = useState(pass.dccaNoCheck);
    const [samStat, setSamStat] = useState(pass.samPassStatus);
    const [samNoCheck, setSamNoCheck] = useState(pass.samNoCheck);
    const [oigStat, setOigStat] = useState(pass.oigPassStatus);
    const [oigNoCheck, setOigNoCheck] = useState(pass.oigNoCheck);
    const user = JSON.parse(sessionStorage.getItem("user"));

    const ProvisioningOptions = ['N/A', 'PASS', 'FAIL']
    const getCurrentDate = (separator = '/') => {
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();

        return `${month < 10 ? `0${month}` : `${month}`}${separator}${date}${separator}${year}`

    }

    const onSubmit = () => {
        let username = user.userID.split("@")[0];
        if (npiStat !== pass.npiPassStatus || npiNoCheck !== pass.npiNoCheck) {
            pass.npiPassStatus = npiStat;
            pass.npiNoCheck = npiNoCheck;
            pass.readableNPIPassedDate = getCurrentDate();
            pass.npiOverrider = username;
            pass.readablePassedDate = getCurrentDate();
        }
        if (dccaStat !== pass.dccaPassStatus || dccaNoCheck !== pass.dccaNoCheck) {
            pass.dccaPassStatus = dccaStat;
            pass.dccaNoCheck = dccaNoCheck;
            pass.readableDCCAPassedDate = getCurrentDate();
            pass.dccaOverrider = username;
            pass.readablePassedDate = getCurrentDate();
        }
        if (samStat !== pass.samPassStatus || samNoCheck !== pass.samNoCheck) {
            pass.samPassStatus = samStat;
            pass.samNoCheck = samNoCheck;
            pass.readableSAMPassedDate = getCurrentDate();
            pass.samOverrider = username;
            pass.readablePassedDate = getCurrentDate();
        }
        if (oigStat !== pass.oigPassStatus || oigNoCheck !== pass.oigNoCheck) {
            pass.oigPassStatus = oigStat;
            pass.oigNoCheck = oigNoCheck;
            pass.readableOIGPassedDate = getCurrentDate();
            pass.oigOverrider = username;
            pass.readablePassedDate = getCurrentDate();
        }
        let foundFail = [npiStat,dccaStat,samStat,oigStat].find((element)=>element==="FAIL" || element==='FAIL')
        if (!foundFail) pass.overallPassed = "PASS";
        else pass.overallPassed = "FAIL";

        let overrideObj = {
            Id: pass.id,
            acctId: member.account.id,
            NPIPassStatus: pass.npiPassStatus,
            NPINoCheck: pass.npiNoCheck,
            NPIPassedDateString: pass.readableNPIPassedDate,
            NPIOverrider: pass.npiOverrider,
            DCCAPassStatus: pass.dccaPassStatus,
            DCCANoCheck: pass.dccaNoCheck,
            DCCAPassedDateString: pass.readableDCCAPassedDate,
            DCCAOverrider: pass.dccaOverrider,
            SAMPassStatus: pass.samPassStatus,
            SAMNoCheck: pass.samNoCheck,
            SAMPassedDateString: pass.readableSAMPassedDate,
            SAMOverrider: pass.samOverrider,
            OIGPassStatus: pass.oigPassStatus,
            OIGNoCheck: pass.oigNoCheck,
            OIGPassedDateString: pass.readableOIGPassedDate,
            OIGOverrider: pass.oigOverrider
            }



        const requestOptions = {
            method: "POST",
            body: JSON.stringify(overrideObj),
            headers: { "Content-type": "application/json: charset=UTF-8" }
        }
        fetch('api/pass/manual-override/' + user.sfid, requestOptions)
            .then((response) => {
                response.json()
                    .then((json) => {
                        if(json.errors !== null && json.errors !== "") alert(json.errors)
                        else if (json.message !== true) {
                            alert('Something went wrong. Please try again.');
                        }
                    })
                    .catch((error) => {
                        console.log("text error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Count response error: " + error);
            });
        setOverride()
    }

    return (
        <Container className="style-box">
            <Row>
                <Col><div className="style-final">Final</div></Col>
                <Col><div className="style-final">Date</div></Col>
                <Col><div className="style-final">Comments</div></Col>
            </Row>
            <Row>
                <Col><div className="style-textbox" style={{color: (pass.overallPassed !== 'PASS') ? 'red' : 'green'}}>{pass.overallPassed}</div></Col>
                <Col><div className="style-textbox">{pass.readablePassedDate}</div></Col>
                <Col>
                    <div className="style-textbox">
                        {pass.overallComment !== null && pass.overallComment !== ""
                                ? pass.overallComment 
                                : "None"}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col><div className="style-passes">DCCA</div></Col>
            </Row>
            <Row>
                <Col>
                    <Dropdown
                        id="p-type-dropdown"
                        style={{ paddingLeft: "4px" }}
                    >
                        <DropdownToggle
                            className="table-button"
                            id="dropdown-dcca-pass-button"
                            variant="light"
                            style={{ textAllign: "right", paddingBottom: "5" }}
                        >{dccaStat}</DropdownToggle>
                        <DropdownMenu
                            style={{ maxHeight: "200px", overflowY: "scroll" }}
                        >
                            {ProvisioningOptions.map((value, index) => (
                                <Dropdown.Item
                                    key={index}
                                    eventKey={value}
                                    type="radio"
                                    value={value}
                                    onSelect={(e) => { setDccaStat(e) }}
                                >
                                    {value}
                                </Dropdown.Item>
                            ))}
                        </DropdownMenu>
                    </Dropdown></Col>
                <Col className="d-flex justify-content-left"><FormCheck
                    style={{ textIndent: "20px" }}
                    id={"dcca-no-check"}
                    checked={dccaNoCheck}
                    onChange={e => { setDccaNoCheck(e.target.checked) }}
                    label="Do not check"
                    
                />
                </Col>
                <Col></Col>
                <Col></Col>
            </Row>
            <Row>
                <Col><div className="style-passes">NPI</div></Col>
            </Row>
            <Row>
                <Col>
                    <Dropdown
                        id="p-type-dropdown"
                        style={{ paddingLeft: "4px" }}
                    >
                        <DropdownToggle
                            className="table-button"
                            id="dropdown-dcca-pass-button"
                            variant="light"
                            style={{ textAllign: "right", paddingBottom: "5" }}
                        >{npiStat}</DropdownToggle>
                        <DropdownMenu
                            style={{ maxHeight: "200px", overflowY: "scroll" }}
                        >
                            {ProvisioningOptions.map((value, index) => (
                                <Dropdown.Item
                                    key={index}
                                    eventKey={value}
                                    type="radio"
                                    value={value}
                                    onSelect={(e) => { setNpiStat(e) }}
                                >
                                    {value}
                                </Dropdown.Item>
                            ))}
                        </DropdownMenu>
                    </Dropdown></Col>
                <Col>
                    <FormCheck
                    style={{ textIndent: "20px" }}
                    id={"npi-no-check"}
                    checked={npiNoCheck}
                    onChange={e => { setNpiNoCheck(e.target.checked) }}
                    label="Do not check" /></Col>
                <Col></Col>
                <Col></Col>
            </Row>
            <Row>
                <Col><div className="style-passes">LEIE</div></Col>
            </Row>
            <Row>
                <Col>
                    <Dropdown
                        id="p-type-dropdown"
                        style={{ paddingLeft: "4px" }}
                    >
                        <DropdownToggle
                            className="table-button"
                            id="dropdown-dcca-pass-button"
                            variant="light"
                            style={{ textAllign: "right", paddingBottom: "5" }}
                        >{oigStat}</DropdownToggle>
                        <DropdownMenu
                            style={{ maxHeight: "200px", overflowY: "scroll" }}
                        >
                            {ProvisioningOptions.map((value, index) => (
                                <Dropdown.Item
                                    key={index}
                                    eventKey={value}
                                    type="radio"
                                    value={value}
                                    onSelect={(e) => { setOigStat(e) }}
                                >
                                    {value}
                                </Dropdown.Item>
                            ))}
                        </DropdownMenu>
                    </Dropdown></Col>
                <Col>
                    <FormCheck
                    style={{ textIndent: "20px" }}
                    id={"oig-no-check"}
                    checked={oigNoCheck}
                    onChange={e => { setOigNoCheck(e.target.checked) }}
                        label="Do not check"
                    /></Col>
                <Col></Col>
                <Col></Col>
            </Row>
            <Row>
                <Col><div className="style-passes">SAM</div></Col>
            </Row>
            <Row>
                <Col>
                    <Dropdown
                        id="p-type-dropdown"
                        style={{ paddingLeft: "4px" }}
                    >
                        <DropdownToggle
                            className="table-button"
                            id="dropdown-dcca-pass-button"
                            variant="light"
                            style={{ textAllign: "right", paddingBottom: "5" }}
                        >{samStat}</DropdownToggle>
                        <DropdownMenu
                            style={{ maxHeight: "200px", overflowY: "scroll" }}
                        >
                            {ProvisioningOptions.map((value, index) => (
                                <Dropdown.Item
                                    key={index}
                                    eventKey={value}
                                    type="radio"
                                    value={value}
                                    onSelect={(e) => { setSamStat(e) }}
                                >
                                    {value}
                                </Dropdown.Item>
                            ))}
                        </DropdownMenu>
                    </Dropdown></Col>
                <Col>
                    <FormCheck
                    style={{ textIndent: "20px" }}
                    id={"modal-check"}
                    checked={samNoCheck}
                        onChange={e => { setSamNoCheck(e.target.checked) }}
                        label="Do not check"
                    />

                </Col>
                <Col></Col>
                <Col></Col>
            </Row>
            <Row className="d-flex justify-content-center">
                <HHIEButton
                    onClick={onSubmit}
                    variant="primary"
                    size="sm"
                    title="Submit"
                    long="true"
                />
                <HHIEButton
                    onClick={
                        () => { setOverride()}
                    }
                    variant="primary"
                    size="sm"
                    title="Cancel"
                    long="true"
                />
            </Row>
        </Container>
    )
}